import type { DivisorNames } from "@tradingApp/helpers/price/types";

interface Params {
  price: number;
  excludedDivisors: DivisorNames[];
}

/**
 * Returns divisor suffix
 */
export function priceGetDivisorName(params: Params): DivisorNames | "" {
  const { price, excludedDivisors } = params;
  if (!excludedDivisors.includes("T") && price > 999999999999) return "T";
  if (!excludedDivisors.includes("B") && price > 999999999) return "B";
  if (!excludedDivisors.includes("M") && price > 999999) return "M";
  if (!excludedDivisors.includes("K") && price > 999) return "K";

  return "";
}
